import { createFileRoute } from '@tanstack/react-router';

import { LegalDocumentPage } from '@/features/legal/LegalDocumentPage';

function PrivacyPolicyPage() {
  return <LegalDocumentPage type="PRIVACY_POLICY" />;
}

export const Route = createFileRoute('/admin/_app/platform-settings/privacy-policy')({
  component: PrivacyPolicyPage,
});
